class AjaxCart extends HTMLElement {
	constructor() {
		super();
        this.overlay = this.querySelector('.ajax-cart-bg');
        this.ajaxCart = this;
	}
    // This executes when the component is loaded
    connectedCallback() {
        this.init();
        this.getCart();

        document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
            const smartcart = event.detail.smartcart; // Get the smartcart instance
            const removedItem = event.detail.item; // Get the item that was removed
            this.checkAndRemoveGiftProduct(smartcart.cart.items, removedItem.id);
        });
        // document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
        //     const smartcart = event.detail.smartcart;
        //     const removedItem = event.detail.item;
        //     const cartItems = smartcart.cart.items;
        //     this.checkAndRemoveGiftProduct(cartItems, removedItem.id);
        // });
        document.addEventListener('rebuy:smartcart.ready', (event) => {
            const smartcart = event.detail.smartcart;
            this.checkAndRemoveGiftProduct(smartcart.cart.items);
        });
        document.addEventListener('rebuy:smartcart.show', (event) => {
            const smartcart = event.detail.smartcart;
            this.checkAndRemoveGiftProduct(smartcart.cart.items);
        });
        document.addEventListener('rebuy:smartcart.hide', (event) => {
            const smartcart = event.detail.smartcart;
            this.checkAndRemoveGiftProduct(smartcart.cart.items);
        });
    }

    checkAndRemoveGiftProduct(cartItems, removedItemId = null) {
        if (cartItems) {
            if (cartItems.length == 0) {
                return false;
            }
            // const giftProductID = 33466541801603;
            const doesGiftPresent = cartItems.find(item => (item.id === theme.settings.giftProductID && item.properties && item.properties.mask_selector));
            if (doesGiftPresent) {
                const hasOtherGifts = cartItems.some(item =>
                    item.properties && item.properties.is_mask && (removedItemId ? item.id !== removedItemId : true)
                );
                if (!hasOtherGifts) {
                    setTimeout(() => {
                        this.removeGiftProduct({ [doesGiftPresent['key']]: 0 });
                    }, 100)
                }
            }

            // const cPapgiftProductID = 33466541801603;
            const doesCpapGiftPresent = cartItems.find(item => (item.id === theme.settings.cPapgiftProductID && item.properties && item.properties.combo_selector));

            if (doesCpapGiftPresent) {
                const hasOtherGiftsIncart = cartItems.some(item =>
                    item.properties && item.properties.is_combo && (removedItemId ? item.id !== removedItemId : true)
                );
                if (!hasOtherGiftsIncart) {
                    setTimeout(() => {
                        this.removeGiftProduct({ [doesCpapGiftPresent['key']]: 0 });
                    }, 100)
                }
            }
        }
    }

    // Function to remove the gift product from the cart
    async removeGiftProduct(updates) {
        try {
            const updateResponse = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    updates: updates
                })
            });

            const updatedCart = await updateResponse.json();
            console.log("Updated cart after removing gift product:", updatedCart);
            // Optionally, update your cart UI here
        } catch (error) {
            console.error("Failed to remove gift product:", error);
        }
    }

    init() {
        console.log("ajax cart loaded");
        document.querySelectorAll('[data-close-cart]').forEach((closeEvent) => {
            closeEvent.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeCart()
        })
        })
        document.querySelector('#open-cart').addEventListener('click', (e) => {
            e.preventDefault();
            this.openCart();
        })
        let itemsList = this.querySelector('.ajax-cart__items');
        if (itemsList) {
            // Set quantity and remove buttons on each cart item 
            let updateBtns = itemsList.querySelectorAll(`[data-key]`);
            updateBtns.forEach(btn => {
                btn.querySelector('i').addEventListener('click', () => {
                    this.removeItem(btn.getAttribute('data-key'));
                });
                btn.querySelector('[data-action="minus"]').addEventListener('click', () => {
                    this.updateQuantity('minus', btn.getAttribute('data-key'), btn.getAttribute('data-qty'));
                })
                btn.querySelector('[data-action="plus"]').addEventListener('click', () => {
                    this.updateQuantity('plus', btn.getAttribute('data-key'), btn.getAttribute('data-qty'));
                })
            });
        }
        //  Set upgrade buttons for selling plans
        if (itemsList) {
            let upgradeBtns = itemsList.querySelectorAll(`[data-upgrade]`);
            console.log(upgradeBtns)
            upgradeBtns.forEach(btn => {
                if (btn.querySelector('div')) {
                    btn.querySelector('div').addEventListener('click', () => {
                        this.setSubscriptions(btn, btn.getAttribute('data-upgrade'))
                    })
                }
                if (btn.querySelector('select')) {
                    btn.querySelector('select').addEventListener('change', () => {
                        this.setSubscriptions(btn, btn.getAttribute('data-upgrade'))
                    })
                }
            })
        }
    }

    async setSubscriptions(wrapper, handle) {
        if(!wrapper.innerHTML.includes('<select')) {
            wrapper.innerHTML = `<div class="loader"> </div>`;
            await fetch(window.Shopify.routes.root + `products/${handle}.js`)
            .then(response => response.json())
            .then(product => {
                wrapper.innerHTML = `
                <select class="${product.selling_plan_groups.length == 0 ? '' : ''}" name="subscription" id="${ handle }-recharge">
                    <optgroup label="Pay Full Price">
                        <option value="onetime"> One-time only </option>
                    </optgroup>
                    ${product.selling_plan_groups.length == 0 ? '' : `
                    <optgroup label="Subscribe and Save 15%">
                        ${product.selling_plan_groups.map(sellingPlanGroup => 
                        sellingPlanGroup.selling_plans.map(sellinPlan => 
                        `<option value="${ sellinPlan.id }" ${ sellinPlan.id == wrapper.getAttribute('data-selling-plan') ? 'selected' : '' }> ${sellinPlan.name} </option>`
                        ).join("")
                        ).join("")}
                    </optgroup>`}
                </select>
                `;
                wrapper.querySelector('select').addEventListener('change', () => {
                    this.setSubscriptions(wrapper, wrapper.getAttribute('data-upgrade'))
                })
            });
        } else {
            let sellingPlan = wrapper.querySelector('select').value;
            if(sellingPlan == 'onetime') {
                sellingPlan = '';
            }
            let qty = this.querySelector(`[data-key="${wrapper.getAttribute('data-item-key')}"]`).getAttribute('data-qty');
            wrapper.innerHTML = `<div class="loader"> </div>`
            try {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                    'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                    id: wrapper.getAttribute('data-item-key'),
                    quantity: qty,
                    selling_plan: sellingPlan
                    })
                });
                if (response.ok) {
                    console.log('Line item updated');
                    this.getCart();
                } else {
                    console.error('Line item update failed:', response.statusText);
                }
            } catch (error) {
                console.error('Error:', error);
                wrapper.innerHTML = `<div class=""> An error occurred </div>`
            }
        }
    }

    updateProgressBar(data) {
        let treeshold = parseInt(this.querySelector('.progress-bar').getAttribute('data-treeshold'));
        let percent = (parseInt(data.total_price) * 100) / treeshold;
        let r = document.querySelector(':root');
        if(percent > 100) {
            percent = 100;
        }
        if(percent == 100) {
            this.querySelector('.progress-bar__msg').innerHTML = `You've unlocked <strong> FREE SHIPPING! </strong>`;
        }else {
            let limit = treeshold - (parseInt(data.total_price));
            limit = parseFloat(limit / 100);
            this.querySelector('.progress-bar__msg').innerHTML = `You are $${limit} away from <strong>FREE SHIPPING</strong>`;
        }
        r.style.setProperty('--progressbar', `${percent}%`);
    }

    openCart() {
        this.classList.add('open');
        //document.querySelector('html').style.overflowY = 'hidden';
    }
    
    closeCart() {
        this.classList.remove('open')
        //document.querySelector('html').style.overflowY = 'auto';
    }

    async getCart() {
        try {
            const response = await fetch('/cart.js');
            const data = await response.json();
            this.updateCart(data);
            this.getRecommendations(data);
            this.updateProgressBar(data);
        } catch (error) {
            console.error('Error:', error);
        }
    }


    async addToCart(itemID, qty, cs) {
        if(itemID != "") {
            let quantity = 1
            if(qty) {
                quantity = qty
            }
            const updates = {
              items: [
                {
                  quantity: qty,
                  id: itemID
                },
              ],
            };
            const properties = {
              ...fetchConfig("javascript"),
              body: JSON.stringify(updates),
            };
        
            try {
                const response = await fetch("/cart/add.js", properties);
                if (!response.ok) {
                    if (response.status === 422) {
                        return response.json().then(errData => {
                            alert((errData.message || "Unprocessable Entity"));
                        });
                    }
                }
                const data = await response.json();
              // get the cart data and then render on the side cart
              /*if(cs) {
                document.querySelector('body').classList.add('has-cross-selling');
                if(window.location.href.includes('?')) {
                  window.location.href = `/products/${cs}?${window.location.href.split('?')[1]}&view=cross_selling`;
                } else {
                  window.location.href = `/products/${cs}?view=cross_selling`;
                }
              } else {*/
                document.querySelector('body').classList.remove('has-cross-selling');
                  this.getCart();
                  this.openCart();
              //}
            } catch (err) {
              console.error(err);
            }
        }
    }
    
    async addFreeGiftIfNotInCart(cartItems, updates, properties = {}) {
        const freeGiftProduct = document.querySelector('[data-freeproductid]');
        // Check if the free gift product exists and if cart items are valid
        if (freeGiftProduct && Array.isArray(cartItems)) {
            const giftProductID = parseInt(freeGiftProduct.dataset.freeproductid);
            const propertiesName = freeGiftProduct.dataset.properties;
            let giftProductInCart = true;
            if (cartItems.length > 0) {
                giftProductInCart = cartItems.some(item => item.id === giftProductID && item.properties && item.properties[propertiesName] == 1);
            } else {
                giftProductInCart = false;
            }
            if (!giftProductInCart) {
                let cpapprop = { 'mask_selector': 1 }
                if (properties.is_combo) {
                    cpapprop = { 'combo_selector': 1 }
                }
                updates.items.push({
                    id: giftProductID,
                    quantity: 1,
                    properties: cpapprop
                });
            }
        }
    }

    async addToCartMultiple(itemID, qty, properties = {}) {
        if (itemID !== "") {
            let quantity = qty || 1; // Default quantity to 1 if not provided
            const itemIDarray = itemID.split(',').map(id => id.trim()); // Trim spaces

            // Construct the cart update request with line item properties
            const updates = {
                items: itemIDarray.map(id => ({
                    id: id, // Shopify requires variant ID, not product ID
                    quantity: quantity,
                    properties: properties // Add line item properties (if any)
                }))
            };


            // Check if gift product is already in cart
            if (window.Rebuy) {
                const cartData = await Rebuy.Cart.getCart();
                await this.addFreeGiftIfNotInCart(cartData.items, updates, properties)
            }
            // Set up request properties
            const requestConfig = {
                ...fetchConfig("javascript"),
                body: JSON.stringify(updates),
            };
            try {
                const response = await fetch("/cart/add.js", requestConfig);
                if (!response.ok) throw new Error(`Error: ${response.statusText}`);

                const data = await response.json();
                console.log("Cart Updated:", data);

                // Handle cart update & UI
                document.querySelector('body').classList.remove('has-cross-selling');
                this.getCart();
                this.openCart();

            } catch (err) {
                console.error("Failed to update cart:", err);
            }
        }
    }

    updateCart(data) {
        let itemsList = this.querySelector('.ajax-cart__items');
        let cartItems = data.items;
        (itemsList) ? itemsList.innerHTML = "" : "";
        if (cartItems.length > 0) {
            this.querySelector('.empty-cart__recommendations').classList.add('hidden');
            this.querySelector('.progress-bar__wrapper').classList.remove('hidden');
            cartItems.forEach(item => {
                itemsList.innerHTML += `
                    <div data-handle="${item.handle}" data-key="${item.key}" data-qty="${item.quantity}" class="ajax-cart__item">
                    <div class="item__data">
                        <a href="${item.url}">
                            <img src="${item.image}" loading="lazy" width="100" height="100" alt="">
                        </a>
                        <div class="flex flex-col justify-between w-full gap-4">
                            <div class="text-base"> ${item.title} </div>
                            <div class="item__quantity flex items-center">
                            <button data-action="minus"> - </button>
                            <input disabled class="w-full max-w-sm" type="text" name="" id="" value="${item.quantity}">
                            <button data-action="plus"> + </button>
                            </div>
                        </div>
                        <div class="item-price flex flex-col items-end">
                            <i class="far fa-trash" aria-hidden="true"></i>
                            <span class="text-base font-bold">
                                $${(parseInt(item.price) / 100).toFixed(2)} 
                            </span>
                        </div>
                    </div>
                    <div class="selling_plan hidden text-base flex items-center gap-2 cursor-pointer" data-upgrade="${item.handle}" data-item-key="${item.key}" ${item.selling_plan_allocation ? `data-selling-plan="${item.selling_plan_allocation.selling_plan.id}"` : ''}>
                    <div class="flex items-center gap-2">
                    ${item.selling_plan_allocation ?
                        `
                        ${item.selling_plan_allocation.selling_plan.name}
                        <svg class="svg-icon" style="width: 1.5rem; height: 1.5rem;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M834.3 705.7c0 82.2-66.8 149-149 149H325.9c-82.2 0-149-66.8-149-149V346.4c0-82.2 66.8-149 149-149h129.8v-42.7H325.9c-105.7 0-191.7 86-191.7 191.7v359.3c0 105.7 86 191.7 191.7 191.7h359.3c105.7 0 191.7-86 191.7-191.7V575.9h-42.7v129.8z"  /><path d="M889.7 163.4c-22.9-22.9-53-34.4-83.1-34.4s-60.1 11.5-83.1 34.4L312 574.9c-16.9 16.9-27.9 38.8-31.2 62.5l-19 132.8c-1.6 11.4 7.3 21.3 18.4 21.3 0.9 0 1.8-0.1 2.7-0.2l132.8-19c23.7-3.4 45.6-14.3 62.5-31.2l411.5-411.5c45.9-45.9 45.9-120.3 0-166.2zM362 585.3L710.3 237 816 342.8 467.8 691.1 362 585.3zM409.7 730l-101.1 14.4L323 643.3c1.4-9.5 4.8-18.7 9.9-26.7L436.3 720c-8 5.2-17.1 8.7-26.6 10z m449.8-430.7l-13.3 13.3-105.7-105.8 13.3-13.3c14.1-14.1 32.9-21.9 52.9-21.9s38.8 7.8 52.9 21.9c29.1 29.2 29.1 76.7-0.1 105.8z"  /></svg>
                        `
                    :
                    `Upgrade to subscription and save 15%`}
                        </div>
                    </div>
                    </div>`;
            });
            this.querySelector('.ajax-cart__footer').classList.remove('hidden');
            itemsList.classList.add('has-items');
            this.querySelector('.subtotal__value').innerHTML = `$${(parseFloat(data.total_price) / 100).toFixed(2)}`;
            this.hasSubscription(cartItems);
        } else {
            if (this.querySelector('.empty-cart__recommendations')) {
                this.querySelector('.empty-cart__recommendations').classList.remove('hidden');
            }
            if (this.querySelector('.ajax-cart__footer')) {
                this.querySelector('.ajax-cart__footer').classList.add('hidden');
            }
            if (itemsList)
                itemsList.innerHTML = `<div class="text-center">
                <strong> Looks like your cart is empty </strong><br>
                <small> Browse your favorite collection </small>
                </div>`;
            itemsList.classList.remove('has-items');
            this.querySelector('.progress-bar__wrapper').classList.add('hidden');
        }
        this.querySelector('.item__count').innerHTML = `(${data.item_count})`;
        document.querySelector('.cart__item-count').innerHTML = `${data.item_count}`;
        this.init();   
    }

    hasSubscription(items) {
        let itemsList = this.querySelector('.ajax-cart__items');
        items.forEach(item => {
            fetch(window.Shopify.routes.root + `products/${item.handle}.js`)
            .then(response => response.json())
            .then(product => {
                product.tags.forEach(tag => {
                    if(tag == 'Subscription') {
                        itemsList.querySelectorAll('.ajax-cart__item').forEach(listItem => {
                            if(listItem.getAttribute('data-handle') == product.handle) {
                                listItem.querySelector('.selling_plan').classList.remove('hidden');
                            }
                        });
                    }
                })
            })
        })
    }


    async getRecommendations(data) {
        if(data.items.length == 0) {
            this.querySelector('.cart__recommendations').classList.add('hidden');
        }else {
            this.querySelector('.cart__recommendations').classList.remove('hidden');
            this.querySelector('.cart__recommendations-items').innerHTML = `<span class="loader"></span>`;
            let id = data.items[0].product_id;

            try {
                const response = await fetch(window.Shopify.routes.root +'recommendations/products.json?product_id='+id+'&limit=5&intent=related');
                const data = await response.json();
                const recommendedProducts = data.products;

                if(recommendedProducts.length > 0) {
                    this.querySelector('.cart__recommendations-items').innerHTML = '';
                    recommendedProducts.forEach(product => {
                        this.querySelector('.cart__recommendations-items').innerHTML += `
                            <div class="cart__recommendations-item ajax-cart__item">
                                <div class="item__data">
                                    <a href="${ product.url }">
                                        <img src="${ product.featured_image}" loading="lazy" width="100" height="100" alt="">
                                    </a>
                                    <div class="flex flex-col w-full gap-2">
                                        <div class="text-base"> ${ product.title } </div>
                                        <div class="text-base font-bold item-price">$${ (parseFloat(product.price) / 100).toFixed(2)}</div>
                                    </div>
                                    <button class="atc-button text-base" onclick="document.querySelector('ajax-cart').addToCart('${ product.variants[0].id }')"> Add </button>
                                </div>
                                ${product.variants.length > 1 ? `
                                <div class="item__data-variants flex flex-col items-end gap-2 justify-between">
                                    <select>
                                        ${product.variants.map(variant => 
                                            `<option value="${ variant.id }"> ${variant.title} </option>`
                                        ).join("")}
                                    </select>
                                </div>
                                ` : ''}
                            </div>
                        `
                    });
                    let recommended = this.querySelectorAll('.cart__recommendations-item');
                    recommended.forEach(item => {
                        if(item.querySelector('select')) {
                            item.querySelector('select').addEventListener('change', () => {
                                item.querySelector('.atc-button').setAttribute('onclick', `document.querySelector('ajax-cart').addToCart('${ item.querySelector('select').value }')`)
                            })
                        }
                    })
                } else {
                    this.querySelector('.cart__recommendations').classList.add('hidden');
                }
              } catch (error) {
                console.error('Error:', error);
              }
        }
    }


    async updateQuantity(action, key, qty) {
        let newQty = action == 'minus' ? parseInt(qty) - 1 : parseInt(qty) + 1;
        try {
            const response = await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                id: key,
                quantity: newQty
                })
            });
            if (response.ok) {
                console.log('Line item updated');
                this.getCart();
            } else {
                console.error('Line item update failed:', response.statusText);
            }
        } catch (error) {
            console.error('Error:', error);
        }
    }

    async removeItem(itemKey) {
        try {
        const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
            id: itemKey,
            quantity: 0
            })
        });
        if (response.ok) {
            console.log('Line item removed');
            this.getCart();
        } else {
            console.error('Line item removal failed:', response.statusText);
        }
        } catch (error) {
        console.error('Error:', error);
        }
    }

}

customElements.define("ajax-cart", AjaxCart);
